const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const SHORT_MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
const DAYS = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes']

export default {
  MONTHS: MONTHS,
  SHORT_MONTHS: SHORT_MONTHS,
  DAYS: DAYS
}
